/** Header carrying the SFE fingerprint of the web bundle that sent a fiscal write. */
export const SFE_FINGERPRINT_HEADER = 'X-SFE-Fingerprint';

/**
 * The SFE fingerprint `vite build` inlined in this bundle
 * (`__EFACTURE_SFE_WEB_BUILD__`, packages/web/sfe-web-build.mjs), or null
 * when there is none: the dev server defines null, and tests define nothing.
 */
export function sfeWebBuildFingerprint(): string | null {
  if (typeof __EFACTURE_SFE_WEB_BUILD__ === 'undefined' || __EFACTURE_SFE_WEB_BUILD__ === null) return null;
  return __EFACTURE_SFE_WEB_BUILD__.fingerprint;
}
